module.exports = __webpack_public_path__ + "img/symbol_7.3f09fe55.png";